import { Text } from "@zapier/design-system";

import { useRouter } from "next/navigation";
import React from "react";

import styles from "./MobileUseCases.module.css";
import { Category } from "src/lib/contentful/client";
import { LibraryTemplate } from "src/server/zsl/templates/types";

interface UseCaseProps {
  templateCount: number;
  title: string;
  slug: string;
}

const UseCase = ({ slug, templateCount, title }: UseCaseProps) => {
  const router = useRouter();

  return (
    <div
      className={styles.card}
      onClick={() => router.push(`/templates/${slug}`)}
      role="button"
      tabIndex={-1}
      onKeyDown={(e) => e.key === "Enter" && router.push(`/templates/${slug}`)}
    >
      <div>
        <Text type="paragraph1Semibold">{title}</Text>
      </div>
      <div>
        <Text type="smallPrint1">
          {templateCount} template{templateCount > 1 ? "s" : ""}
        </Text>
      </div>
    </div>
  );
};

interface UseCasesProps {
  categories: Category[];
  templates: LibraryTemplate[];
}

export const MobileUseCases = ({ categories, templates }: UseCasesProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <Text type="pageHeader7">Use Cases</Text>
      </div>
      {categories.map((category) => {
        const count = templates.filter((t) =>
          t.meta.categories.includes(category.slug),
        ).length;

        return (
          <UseCase
            key={category.slug}
            title={category.name}
            templateCount={count}
            slug={category.slug}
          />
        );
      })}
    </div>
  );
};
